var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4345 4.17267C19.5668 4.38058 19.3401 4.6228 19.0998 4.56818C18.6298 4.42818 18.1098 4.35818 17.5798 4.35818H14.2796C14.1223 4.35818 13.9743 4.28424 13.8798 4.15855L12.7298 2.62818C12.589 2.42863 12.7221 2.13818 12.9664 2.13818H15.7198C17.2808 2.13818 18.6559 2.94892 19.4345 4.17267Z",
    fill: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.14 6.67818C19.71 6.36818 19.22 6.13818 18.69 6.00818C18.33 5.90818 17.96 5.85818 17.58 5.85818H13.86C13.28 5.85818 13.24 5.80818 12.93 5.39818L11.53 3.53818C10.88 2.66818 10.37 2.13818 8.74 2.13818H6.42C3.98 2.13818 2 4.11818 2 6.55818V17.7182C2 20.1582 3.98 22.1382 6.42 22.1382H17.58C20.02 22.1382 22 20.1582 22 17.7182V10.2782C22 8.78818 21.27 7.47818 20.14 6.67818ZM14.39 16.4782H9.6C9.21 16.4782 8.91 16.1682 8.91 15.7782C8.91 15.3982 9.21 15.0782 9.6 15.0782H14.39C14.78 15.0782 15.09 15.3982 15.09 15.7782C15.09 16.1682 14.78 16.4782 14.39 16.4782Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.cf57d0d10546d47f030d09c4b4316699.svg";
export { ForwardRef as ReactComponent };